function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B9B8C4",
  d: "M437.397 45.568c-3.733-2.176-92.16-52.459-191.317-.448-61.035 32.043-116.843 15.061-139.413 5.504V21.333C106.667 9.557 97.131 0 85.333 0 73.536 0 64 9.557 64 21.333v469.334C64 502.464 73.536 512 85.333 512c11.797 0 21.333-9.536 21.333-21.333V309.653c16.832 5.419 39.168 10.453 65.195 10.432 28.203 0 60.544-5.867 94.059-23.445 77.589-40.789 146.987-2.219 150.08-.427a21.37 21.37 0 0021.291.021A21.326 21.326 0 00448 277.738V64a21.335 21.335 0 00-10.603-18.432z"
});
function SvgFlag(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
export default __webpack_public_path__ + "03dffc67f3309760c31efdd2ac75bf9b.svg";
export { SvgFlag as ReactComponent };